<template>
  <div class="app-download">
    <img class="bg-img" :src="bgImg" />

    <img
      :src="androidButoon"
      @click="downloadApp"
      style="width: 189px; margin-top: 16px"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: "https://bopin.oss-cn-shenzhen.aliyuncs.com/adv/downloadappbg.png",
      iosButoon: "https://bopin.oss-cn-shenzhen.aliyuncs.com/adv/iosButton.png",
      androidButoon:
        "https://bopin.oss-cn-shenzhen.aliyuncs.com/adv/androidButton.png",
    };
  },
  methods: {
    downloadApp() {
      const downloadUrl =
        "https://oss.abopin.com/app/1938133600302649345/file/175212987078681491777.apk"; // 替换为实际的下载链接
      const fileName = "174954988662984368525.apk"; // 替换为实际的文件名

      // 创建 a 标签
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = downloadUrl;
      a.setAttribute("download", fileName);

      // 将 a 标签添加到页面并触发点击事件
      document.body.appendChild(a);
      a.click();

      // 从页面中移除 a 标签
      document.body.removeChild(a);
    },
  },
};
</script>

<style>
.app-download {
  height: 100vh;
  width: 100%;
  text-align: center;
}
.bg-img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/app-download/index.vue